// Generated by CoffeeScript 2.7.0
var IDNumber;

import Base from './base.js';

export default IDNumber = class IDNumber extends Base {
  getDisappearedFieldIdsOnInit() {
    return _.pluck(this.logic_rule, 'field_ids');
  }

};
